'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:SearchSurveyCtrl
 * @description
 * # SearchSurveyCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp').controller('SearchSurveyCtrl',
        [
            '$scope', '$routeParams', '$location', '$http', 'Session', '$uibModal', 'ReportService', 'ApiUrl',
            function($scope, $routeParams, $location, $http, Session, $uibModal, ReportService, ApiUrl) {
                var sessionObject = Session.getSessionObject();
                if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isProjectAdmin)) {
                    $location.url('/');
                    return;
                }

                var _grantapiUrl = ApiUrl.url('/Grant/');
                var _surveyapiUrl = ApiUrl.url('/Survey/');
                var _projectapiUrl = ApiUrl.url('/Project/');
                var _divisionapiUrl = ApiUrl.url('/Division/');
                var _uploadapiUrl = ApiUrl.url('/Upload/');

                $scope.isOpen = true;
                $scope.grantIsOpen = true;
                $scope.input = {
                    filter: null,
                    custom: false,
                    curated: false,
                    profile: false
                };
                //Needs to be a nested object to hold the base survey to escape the child scope
                $scope.BaseSurvey = {};

                $http.get(_projectapiUrl + 'GetProjectsWhereUserIsAdmin')
                    .then(function (response) {
                        $scope.projects = response.data;
                        $scope.selectedProjects = response.data;
                    });
                

                $http.get(_uploadapiUrl + 'UserRelationshipOptions')
                    .then(function (response) {
                        $scope.UserRelationshipOptions = response.data;
                    });

                $scope.selectProject = function() {
                    $scope.getDivisions($scope.Project);
                    $scope.selectedProjects = [$scope.Project];
                };

                $scope.getDivisions = function (project) {
                    if (project.Expanded) {
                        project.Expanded = false;
                    } else {
                        $scope.selectedProjects.forEach(function (tempproject) {
                            if (tempproject.Expanded) {
                                tempproject.Expanded = false;
                            }
                        });

                        $http.get(_divisionapiUrl + 'Divisions/' + project.ProjectId)
                            .then(function (response) {
                                $scope.selectedDivisions = response.data;
                                $scope.divisions = response.data;
                                project.Expanded = true;
                            });
                    }
                };

                $scope.selectDivision = function () {
                    if ($scope.Division) {
                        $scope.getGrants($scope.Division);
                        $scope.selectedDivisions = [$scope.Division];
                    }
                };

                $scope.getGrants = function (division) {
                    if (division.Expanded) {
                        division.Expanded = false;
                    } else {
                        $scope.selectedDivisions.forEach(function (tempdivision) {
                            if (tempdivision.Expanded) {
                                tempdivision.Expanded = false;
                            }
                        });

                        $http.get(_grantapiUrl + 'GetGrantsFromDivision/' + division.DivisionID)
                            .then(function (response) {
                                $scope.grants = response.data;
                                division.Expanded = true;
                            });
                    }
                };

                $scope.getSurveys = function(grant) {
                    if (grant.Expanded) {
                        grant.Expanded = false;
                    } else {
                        $scope.grants.forEach(function(tempgrant) {
                            if (tempgrant.Expanded) {
                                tempgrant.Expanded = false;
                            }
                        });

                        $http.get(_surveyapiUrl + 'GetSurveysForGrant/' + grant.GrantID)
                            .then(function(response) {
                                $scope.surveys = response.data;
                                grant.Expanded = true;
                            });
                    }
                };

                $scope.downloadData = function (survey) {
                    $scope.input.custom = true;
                    ReportService.downloadDataCsv(survey.SurveyID, $scope.input);
                };

                $scope.downloadAggregateData = function () {
                    if ($scope.BaseSurvey.baseSurvey) {
                        ReportService.downloadAggregateDataCsv($scope.BaseSurvey.baseSurvey.SurveyID, $scope.input);
                    }
                };
            }
        ]);
